<template>
    <div class="main-box">
        <!-- 护理日志 -->
        <div class="main-title mb-40">
            <div class="title-box">
                <div class="black font34 bold">护理日志</div>
            </div>
        </div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="20"
            :immediate-check="false">
            <div class="main-diary" v-for="(item, index) in nursingList" :key="index">
                <div class="diary-title">
                    <div class="fl font28 gray">{{ item.createDate }}</div>
                    <div class="fr middle" @click="toEditDiary(item)">
                        <img class="diary-icon middle" alt=""
                            src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/edit-icon.png" />
                    </div>
                    <div v-if="item.status == 0" class="fr diary-btn font26">未填写</div>
                </div>
                <div class="diary-line">护理门店：{{ item.storeName }}</div>
                <div class="diary-line">美疗师：{{ item.therapists }}</div>
                <div class="diary-line">开单顾问：{{ item.counselorName }}</div>
                <div class="diary-line">护理备注：{{ item.remark ? item.remark : "" }}</div>
            </div>
        </van-list>
    </div>
</template>

<script>
import request from "@/utils/request";
export default {
    props: {
        custId: {
            type: String,
        },
    },
    data() {
        return {
            list: [],
            phone: "",
            page: 1,
            total: 0,
            nursingList: [],
            loading: true, //list
            finished: false, //list
        };
    },
    mounted() {
        this.onLoad();
        this.phone = this.$route.query.phone
    },
    methods: {
        // 列表上拉加载
        onLoad() {
            const limit = 10
            request({
                url: `/nursing/list?custId=${this.custId}&limit=${limit}&page=${this.page}`,
                method: "get",
            })
                .then((res) => {
                    this.nursingList = this.page == 1 ? res.data : this.nursingList.concat(res.data);
                    this.page += 1;
                    if (res.data && res.data.length < limit) {
                        this.finished = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        toEditDiary(item) {
            this.$router.push({ name: "editDiary", query: { data: JSON.stringify(item), phone: this.phone } });
        },
    },
};
</script>
<style scoped>
.mr-10 {
    margin-right: 10px;
}
.D5F3F8 {
    color: #d5f3f8;
}
.black {
    color: #35434c;
}
.gray {
    color: #a0acb5;
}

/* ----- */
.main-box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    /* padding: 0 30px 50px 30px; */
    margin-top: 40px;
}
.main-title {
    justify-content: flex-start;
    align-items: center;
}
.main-title-more {
    display: flex;
    justify-content: space-around;
}
.main-title .icon {
    width: 40px;
    height: 40px;
}
.main-archives {
    width: 690px;
    height: 227px;
    background: #ffffff;
    box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 30px;
    padding: 40px 40px;
    box-sizing: border-box;
}
.archives-item .item-icon {
    width: 46px;
    height: 46px;
}
.main-consume {
    width: 690px;
    background: #ffffff;
    box-sizing: border-box;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}
.consume-item {
    width: 330px;
    height: 131px;
    margin-bottom: 20px;
    background: #fafafe;
    border-radius: 12px;
    text-align: left;
    padding: 20px 50px;
    box-sizing: border-box;
}
.consume-item .item-icon {
    width: 46px;
    height: 46px;
}
.main-title-more .title-box {
    width: 70%;
    align-items: center;
}
.main-title-more .more {
    width: 25%;
}
.main-diary {
    width: 690px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 30px;
    padding: 40px 30px;
    margin-bottom: 30px;
}
.diary-title {
    width: 100%;
    height: 46px;
    line-height: 46px;
}
.diary-title .diary-icon {
    width: 34px;
    height: 34px;
}
.diary-title .diary-btn {
    height: 46px;
    padding: 0 14px;
    background: #ff8519;
    border-radius: 23px;
    color: #fff;
    line-height: 46px;
    margin-right: 30px;
}
.diary-line {
    margin-top: 30px;
    width: 100%;
    font-size: 28px;
    color: #35434c;
}
</style>
